import * as React from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import { getObjVal, mergeClasses } from '../constants';
import { GlobalStatusType } from '../types';
import Icon from '../widgets/Icons';

const statusData = {
  warning: {
    icon: Icon.Exclamation,
    title: 'Warning',
  },
  danger: {
    icon: Icon.ExclamationCircle,
    title: 'Error',
  },
  info: {
    icon: Icon.ICircle,
    title: 'Info',
  },
  success: {
    icon: Icon.CheckCircle,
    title: 'Success!',
  },
};

type ToastNotificationProps = {
  onDismiss: (arg0: number) => any;
  status: GlobalStatusType;
};

export const ToastNotification = (props: ToastNotificationProps) => {
  const { onDismiss, status } = props;
  const { color, message, serialNumber, title } = status;
  const Svg = getObjVal(statusData, `${color}.icon`, Icon.ICircle);

  return (
    <Toast className={mergeClasses(['toast-status', `theme-${color}`])}>
      <div className="toast-icon">
        <Svg size={20} />
      </div>
      <div className="toast-content">
        <ToastHeader toggle={() => onDismiss(serialNumber)}>
          {title || getObjVal(statusData, `${color}.title`, 'Message')}
        </ToastHeader>
        <ToastBody>{message}</ToastBody>
      </div>
    </Toast>
  );
};

export type Props = {
  status: Array<GlobalStatusType>;
  onDismiss: (arg0: number) => any;
};

const GlobalStatusReporter = (props: Props) => {
  const { status, onDismiss } = props;
  if (!status.length) {
    return null;
  }
  return (
    <div className="toasts-container">
      {status.map((status: GlobalStatusType) => (
        <ToastNotification
          onDismiss={onDismiss}
          status={status}
          key={status.serialNumber}
        />
      ))}
    </div>
  );
};

export default GlobalStatusReporter;
